/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
app.helpers = app.helpers || {};


(function () {
  'use strict';
  
  /**
   * Хелпер для формирования ошибок.
   */
  app.helpers.ErrorHelper = {
    /**
     * Обработка непредвиденных ошибок валидации
     * @param {Array} errorsList Список ошибок
     * @param {String} where Где возникла проблема (для вывода в сообщения об ошибках)
     */
    globalValidationError: function (errorsList, where) {
      var globalError = where + ' '
        + app.helpers.DeclinationHelper.format(errorsList.length, ['произошла', 'произошли', 'произошли'])
        + ' '
        + app.helpers.DeclinationHelper.format(errorsList.length, ['ошибка', 'ошибки', 'ошибки'])
        + ':';
      errorsList.forEach(function (error, index) {
        globalError += ' «' + error.message + '»';
        if (index < errorsList.length - 1) {
          globalError += ',';
        }
        var err = new RangeError(where + ' произошла непредвиденная ошибка валидации поля ' + error.field + ': ' + error.message);
        if (typeof Raven !== 'undefined' && typeof Raven.captureException === 'function') {
          Raven.captureException(err);
        }
      });
      globalError += '.';
      Backbone.trigger('global-error', {error: globalError});
    },

    /**
    * Обработка ошибок
    * @param {String} errorMessage Текст ошибки
    */
    throwError: function (errorMessage) {
      var error = new SyntaxError(errorMessage);
      if (typeof Raven !== 'undefined' && typeof Raven.captureException === 'function') {
        Raven.captureException(error);
        return;
      }
      throw error;
    }
    
  };
})();

}.call(window));